import { createAction, props } from '@ngrx/store';

export const addCartNote = createAction('[Cart] Add Note', props<{ notes: string }>());

export const cartReset = createAction('[Cart] Reset on checkout success');
